module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admintradereport/admintradereport.component.css
// module id = ./src/app/admintradereport/admintradereport.component.css
// module chunks = main